import React from 'react';
import GoldenCube from './GoldenCube';
import { ArrowRight } from 'lucide-react';

const HeroSection = ({ onDownloadClick }) => {
  return (
    <section style={{
      minHeight: '100vh',
      background: '#000000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      paddingTop: '80px'
    }}>
      {/* Star background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url('https://images.unsplash.com/photo-1634207783795-48c0e8861d95?q=80&w=2000')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.3,
        zIndex: 0
      }} />

      <div className="hero-container" style={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '1400px',
        padding: '0 7.6923%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '60px'
      }}>
        {/* Left: Text Content */}
        <div className="hero-text" style={{
          flex: 1,
          maxWidth: '600px'
        }}>
          <h1 className="hero-title" style={{
            fontSize: '66px',
            fontWeight: 600,
            lineHeight: 1.1,
            letterSpacing: '-0.62px',
            color: '#FFFFFF',
            marginBottom: '24px'
          }}>
            UNIVERSE ENGINE THEORY
          </h1>
          
          <p className="hero-subtitle" style={{
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: 1.5,
            color: '#FFFFFF',
            marginBottom: '16px'
          }}>
            The future constrains the past.
          </p>
          
          <p className="hero-description" style={{
            fontSize: '18px',
            fontWeight: 400,
            lineHeight: 1.5,
            color: 'rgba(255, 255, 255, 0.85)',
            marginBottom: '40px'
          }}>
            What if the laws of physics aren't fundamental? What if they emerge from a single requirement: that the universe must reach its final state? We present a mathematical framework where causality flows both ways, and the boundary conditions of time itself determine everything in between.
          </p>

          <div className="hero-buttons" style={{
            display: 'flex',
            gap: '16px',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}>
            <button 
              onClick={onDownloadClick}
              style={{
                background: '#00FFD1',
                color: '#000000',
                border: 'none',
                borderRadius: '0px',
                padding: '14px 24px',
                fontSize: '18px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.4s ease-in-out',
                minHeight: '56px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(0, 255, 209, 0.1)';
                e.target.style.color = '#00FFD1';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#00FFD1';
                e.target.style.color = '#000000';
              }}>
              READ THE PAPER
              <ArrowRight size={20} />
            </button>

            <button 
              onClick={() => document.getElementById('proof').scrollIntoView({ behavior: 'smooth' })}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '0px',
                padding: '14px 24px',
                fontSize: '18px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.4s ease-in-out',
                minHeight: '56px'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#FFFFFF';
                e.target.style.color = '#000000';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.color = '#FFFFFF';
              }}>
              SEE THE PREDICTIONS
            </button>
          </div>
        </div>

        {/* Right: Golden Cube */}
        <div className="hero-cube" style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <GoldenCube />
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .hero-container {
            flex-direction: column;
            padding: 40px 20px !important;
            gap: 40px !important;
          }
          .hero-text {
            max-width: 100% !important;
          }
          .hero-title {
            font-size: 48px !important;
          }
          .hero-cube {
            width: 100%;
            justify-content: center;
          }
        }
        @media (max-width: 768px) {
          .hero-title {
            font-size: 36px !important;
          }
          .hero-subtitle {
            font-size: 18px !important;
          }
          .hero-description {
            font-size: 16px !important;
          }
          .hero-buttons {
            flex-direction: column;
            width: 100%;
          }
          .hero-buttons button {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;